import React from 'react';
import { Flex } from 'rebass';
import Styled from 'styled-components';
import { Caption } from '../FontStyles';
import baseTheme from '../../themes/baseTheme';
import { Popover, Position, Pane, Menu } from 'evergreen-ui';

const IconButtonCont = Styled(Flex)`

i {
  max-width: 24px;
}
i:hover {

  border-radius: ${baseTheme.radius};
  background-color: ${baseTheme.colors.lightestGrey};
}

`;
class IconButton extends React.PureComponent {
  render() {
    return (
      <Popover
        bringFocusInside
        content={
          <Menu>
            <Menu.Group>
              <Menu.Item>
                <Caption>Message</Caption>
              </Menu.Item>
              <Menu.Item>
                <Caption>Transfer to new clinician</Caption>
              </Menu.Item>
              <Menu.Item>
                <Caption>Upload data</Caption>
              </Menu.Item>
            </Menu.Group>
            <Menu.Divider />
            <Menu.Group>
              <Menu.Item onSelect={this.props.removeRow} intent="danger">
                <Caption color="palevioletred"> Delete...</Caption>
              </Menu.Item>
            </Menu.Group>
          </Menu>
        }
        position={Position.BOTTOM_LEFT}
      >
        <Pane style={{ cursor: 'pointer' }}>
          <IconButtonCont mr={3}>
            <i class="material-icons">more_horizontal</i>
          </IconButtonCont>
        </Pane>
      </Popover>
    );
  }
}
export default IconButton;
